import { Box, Card, CardContent, Grid, styled } from "@mui/material";
import Typography from "@mui/material/Typography";
import commercialLogo from "../../../resources/images/bank/commercial.png";
import sampathLogo from "../../../resources/images/bank/sampath.png";

const StyledCard = styled(Card)(({ theme }) => ({
  '& .MuiCardContent-root': {
    paddingBottom: '12px !important',
  }
}));

interface BankDetailsProps {
  label: string;
  value: string | number;
}

const BankDetailsItem: React.FC<BankDetailsProps> = ({ label, value }) => {
  return (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="subtitle1" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="subtitle1" color="textPrimary">
        {value}
      </Typography>
    </Box>
  );
};

const BankDetails = () => {

  return (
    <Grid container spacing={4} sx={{ marginTop: '12px' }}>

      <Grid size={{ xs: 12 }}>
        <Typography variant="h6">How to Pay The Bill</Typography>
        <StyledCard variant="outlined" sx={{ marginTop: '12px' }} >
          <Typography variant="body1" sx={{ margin: '12px' }} >Please transfer the amount to any of the following bank accounts and share the payment receipt via email or WhatsApp.</Typography>
          <Typography variant="body1" sx={{ margin: '12px' }} >Email: gyminify@gmail.com</Typography>
          <Typography variant="body1" sx={{ margin: '12px' }} >Whatsapp: 0771 399 297</Typography>
        </StyledCard>
      </Grid>

      <Grid size={{ xs: 12, lg: 6 }}>
        <Box sx={{ maxWidth: { xs: '100%' }, width: '100%' }}>
          <StyledCard variant="outlined" >
            <CardContent sx={{ paddingBottom: "12px" }}>
              <img src={commercialLogo} style={{ height: "36px" }} alt="" />
              <BankDetailsItem label="Bank:" value='Commercial Bank' />
              <BankDetailsItem label="Account Name:" value='WEBSCENTIC SOFTWARE SOLUTIONS' />
              <BankDetailsItem label="Account Number:" value='1001003045' />
              <BankDetailsItem label="Branch:" value='Pilimathalawa' />
            </CardContent>
          </StyledCard>
        </Box>
      </Grid>

      <Grid size={{ xs: 12, lg: 6 }}>
        <Box sx={{ maxWidth: { xs: '100%' }, width: '100%' }}>
          <StyledCard variant="outlined" >
            <CardContent sx={{ paddingBottom: "12px" }}>
              <img src={sampathLogo} style={{ height: "36px" }} alt="" />
              <BankDetailsItem label="Bank:" value='Sampath Bank' />
              <BankDetailsItem label="Account Name:" value='WEBSCENTIC SOFTWARE SOLUTIONS' />
              <BankDetailsItem label="Account Number:" value='115014038769' />
              <BankDetailsItem label="Branch:" value='Pilimathalawa' />
            </CardContent>
          </StyledCard>
        </Box>
      </Grid>
    </Grid>
  );
}

export default BankDetails;